// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"89b4a0c3","101":"5635e5f6","225":"20830ec1","682":"4bf7b163","956":"0e930499","966":"48d54046"}[chunkId] + ".chunk.js";
};